import { Box, Grid } from '@chakra-ui/react';
import { InputField } from '../../../inputs/InputField/inputField';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
// @ts-ignore
import PrismaZoom from 'react-prismazoom';
import ZoomGameMockUp from '../../ZoomGameMockUp/zoomGameMockUp';

export const SetNameAndSymbol = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading description={t('form.steps.setNameAndSymbol.desc')} label={t('form.steps.setNameAndSymbol.label')}>
					{t('form.steps.setNameAndSymbol.heading')}
				</FormSectionHeading>
				<Grid
					templateColumns="auto 140px"
					gridGap="20px"
					w="100%"
				>
					<InputField
						label={t('form.fields.gameName')}
						name="name"
						placeholder="Game"
					/>
					<InputField
						label={t('form.fields.symbol')}
						name="symbol"
						placeholder="ETH"
					/>
				</Grid>
				<FormSectionAddon>
					<Box>{t('form.steps.cantedit')}</Box>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<ZoomGameMockUp
					ctaColor={(values as any).colors.actionColor}
					textColor={(values as any).colors.textColor}
					bgColor={(values as any).colors.backgroundColor}
					zoom={{ x: 20, y: -70, width: 400, height: Number('280') }}
					nameActive={true}
					name={(values as any).name}
					video={(values as any).video}
					screenshots={(values as any).screenshots}
					gameCover='assets/default/default-cover-game.png'
				/>
			</RightColumn>
		</TwoColumn>
	);
};
